import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";

import { Chevron } from "../../../components/VFIcon";

const NavEntry = ({ className, link, subLinkList }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => {
    setIsOpen((state) => !state);
  };

  let chevron;
  if (subLinkList) {
    chevron = <Chevron onClick={toggleNav} />;
  }

  return (
    <div
      className={classnames(className, "nav-entry", {
        "nav-entry-active": isOpen,
      })}
    >
      {link}
      {chevron}
      {subLinkList}
    </div>
  );
};

NavEntry.propTypes = {
  className: PropTypes.string,
  link: PropTypes.node.isRequired,
  subLinkList: PropTypes.node,
};

NavEntry.defaultProps = {
  className: null,
  subLinkList: null,
};

export default NavEntry;
